import { useRef } from "react";

export default function PaymentDrawer(props) {
  // Control whether the drawer is fully open or hidden.

  // We’ll track the current vertical translation (in px) during drag.

  // Store the initial touch/mouse Y position when the user starts dragging.
  const startYRef = useRef(0);

  const translateYRef = useRef(0);

  // Store the drawer’s height for calculations.
  const drawerRef = useRef(null);

  const handleCloseClick = () => {
    props.setIsOpen(false);
    props.setTranslateY(0);
  };

  const draggingRef = useRef(false);

  const handleDragStart = (e) => {
    e.preventDefault();
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    startYRef.current = clientY;
    draggingRef.current = true;

    // Add listeners to document
    document.addEventListener("mousemove", handleDragMove);
    document.addEventListener("mouseup", handleDragEnd);
    document.addEventListener("touchmove", handleDragMove);
    document.addEventListener("touchend", handleDragEnd);
  };

  const handleDragMove = (e) => {
    if (!draggingRef.current || !props.isOpen) return;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const delta = clientY - startYRef.current;
    if (delta > 0) {
      props.setTranslateY(delta);
      translateYRef.current = delta; // keep ref in sync
    }
  };

  const handleDragEnd = () => {
    draggingRef.current = false;

    const drawerHeight = drawerRef.current?.offsetHeight || 0;
    if (translateYRef.current > drawerHeight / 2) {
      handleCloseClick();
    } else {
      props.setTranslateY(0);
    }

    // Clean up listeners
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleDragMove);
    document.removeEventListener("touchend", handleDragEnd);
  };

  const freeAiDrawerContent = () => {
    return (
      <>
        <p className="text-h3 text-color-black bottom-margin-m">
          FYLL OPP ROMMET MED AI
        </p>
        <p
          className="text-color-black bottom-margin-m"
          style={{ lineHeight: "1.2" }}
        >
          Ved hjelp av AI kan du nå utvide rommet ditt. Spørsmålene genereres av
          innholdet i rommet, og bygger videre på det 😈 🤖
        </p>
        <p
          className="text-color-black bottom-margin-l"
          style={{ lineHeight: "1.2" }}
        >
          De første 3 spørsmålene får dere gratis 🤑
        </p>

        <div
          className=" button-primary black-fill button-text-l text-color-pink shadow-pink-opaque box-button-center bottom-margin-l"
          onClick={() => {
            props.socket.emit("free ai", props.roomName);
            handleCloseClick();
          }}
        >
          FYLL OPP MED AI
        </div>
      </>
    );
  };

  const paidAiDrawerContent = () => {
    return (
      <>
        <p className="text-h3 text-color-black bottom-margin-m">
          {props.start ? <>FYLL OPP ROMMET MED AI</> : <>SKRIVESPERRE?</>}
        </p>
        <p
          className="text-color-black bottom-margin-l"
          style={{ lineHeight: "1.2" }}
        >
          {props.start ? (
            <>
              Ved hjelp av AI kan du utvide rommet ditt med 20 spørsmål for 20
              kr. Spørsmålene genereres av innholdet i rommet ditt, og bygger
              videre på det 😈 🤖
            </>
          ) : (
            <>
              Ved hjelp av AI kan du legge til 20 spørsmål for 20 kr.
              Spørsmålene genereres av innholdet som allerede er i rommet, og
              bygger videre på det 😈 🤖
            </>
          )}
        </p>
        <div className="container" style={{ marginBottom: "30px" }}>
          <input
            className="button-primary shadow-black text-h3"
            autoComplete="tel-national"
            type="tel"
            maxLength="8"
            inputMode="numeric"
            pattern="[0-9]*"
            value={props.mobileNumber}
            onChange={props.onChangeMobileInput}
            placeholder={"Mobilnummer"}
            onBlur={() =>
              localStorage.setItem("mobileNumber", props.mobileNumber)
            }
          />
        </div>
        <vipps-mobilepay-button
          type="button"
          brand="vipps"
          language="no"
          variant="primary"
          rounded="false"
          verb="pay"
          stretched="true"
          branded="true"
          loading="false"
          onClick={() => {
            if (props.mobileNumber.length < 8) {
              props.showInfoMessage(
                "warning",
                "Mobilnummeret må være 8 siffer langt",
                false,
                "medium",
                false
              );
              return;
            }
            props.payment(props.mobileNumber);
            handleCloseClick();
          }}
        ></vipps-mobilepay-button>
        <p
          style={{ fontSize: "14px", marginTop: "6px" }}
          className="text-color-black bottom-margin-l"
        >
          Se{" "}
          <span
            onClick={() =>
              window.open("https://fyl.la/terms-of-sale", "_blank")
            }
            style={{
              textDecoration: "underline",
              lineHeight: "1.2",
              cursor: "pointer",
            }}
          >
            betalingsvilkår
          </span>{" "}
          for spørsmål, kjøpet kan ikke angres.
        </p>
      </>
    );
  };

  return (
    <div>
      {/* Trigger button */}

      {/* Overlay (optional) */}
      {props.isOpen && (
        <div
          className="drawer-overlay"
          onClick={handleCloseClick}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        />
      )}

      {/* Drawer container */}
      <div
        ref={drawerRef}
        className="drawer"
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          // Start fully hidden below the screen if closed
          transform: props.isOpen
            ? `translateY(${props.translateY}px)`
            : "translateY(100%)",
          transition: props.translateY === 0 ? "transform 0.3s ease" : "none",
          background: "#fff",
          boxShadow: "0 -2px 6px rgba(0, 0, 0, 0.2)",
          // Ensure it’s on top of other content
          zIndex: 9999,
        }}
      >
        {/* Simple drag handle area */}
        <div
          className="drawer-handle"
          style={{
            width: "100%",
            height: "30px", // draggable area
            cursor: "grab",
            position: "relative",
            touchAction: "none",
          }}
          onMouseDown={handleDragStart}
          onTouchStart={handleDragStart}
        />
        <div
          style={{
            width: "50px",
            height: "6px",
            backgroundColor: "#ccc",
            borderRadius: "3px",
            position: "absolute",
            top: "3%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
        {/* Drawer content goes here */}
        <div
          // style={{ paddingLeft: "1rem", paddingRight: "1rem" }}

          style={{
            maxWidth: "500px",
            margin: "0 auto",
            width: "100%",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            boxSizing: "border-box", // ✅ ensures padding doesn't add overflow
          }}
        >
          {props.showPaidPaymentDrawer
            ? paidAiDrawerContent()
            : freeAiDrawerContent()}
        </div>
      </div>
    </div>
  );
}
